export default __webpack_public_path__ + "static/media/logo-item.0138be6e.png";